import React, { Component, Fragment } from "react";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    Table,
    UncontrolledPopover,
    PopoverHeader,
    PopoverBody,
    Collapse
} from 'reactstrap';
import Switch from "react-switch";
import {
    DropdownToggle, DropdownMenu,
    Nav, NavItem, NavLink,
    UncontrolledButtonDropdown,
    Button
} from 'reactstrap';
import cx from "classnames";
import dateFormat from "dateformat";
import Paginate from "./Paginate";
import NoRecord from "./NoRecord";
import {
    confirmBox,
    confirmBoxWithImage,
    convertDateToUtc,
    convertUTCToLocalTime,
    decodeString,
    randstr,
    showToast,
    removeDuplicateValues,
    getSessionValue
} from "./Appcommon";
import AnalyticsPreview from "../Components/Analytics/AnalyticsPreview";
import { faTrash } from "@fortawesome/free-solid-svg-icons/faTrash";
import { faCopy } from "@fortawesome/free-solid-svg-icons/faCopy";
import { faEye } from "@fortawesome/free-solid-svg-icons/faEye";
import requestApi from "../services/requestApi.service";
import { faAnglesDown } from "@fortawesome/free-solid-svg-icons/faAnglesDown";
import Analytics from "../Components/Campaigns/Analytics";
import { faAnglesUp } from "@fortawesome/free-solid-svg-icons/faAnglesUp";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons/faCaretDown";


export default class ListTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formData: props.formData !== undefined && props.formData.length > 0 ? props.formData : [],
            fields: props.fields !== undefined && props.fields.length > 0 ? props.fields : [],
            showRowCount: props.showRowCount || false,
            spaceBeforeCell: props.spaceBfCell !== undefined ? props.spaceBfCell : true,
            config: props.config || {},
            labelIndex: props.labelIndex || 3,
            aliasIndex: props.aliasIndex || 2,
            accordianStatus: [props.defaultaccordianStatus],
            accordianComponent: [],
            selectedRows: [],
            isCheckBoxEnabled: [],
            masterChecked: false,
            spotData: [],
            isNeedMassEditPanel: false,
            showLoaderIndex: [],
            userformname: process.env.REACT_APP_USER_FORMNAME,
            userid: getSessionValue("loginuserid")
        }
    }

    componentDidMount() {
        this.getAccordianComponent(this.props.accordianName, 0);
    }

    toggleAccordian = (row) => {
        let { accordianStatus } = this.state;
        if (accordianStatus[row] !== undefined) {
            accordianStatus[row] = !accordianStatus[row];
        } else {
            accordianStatus[row] = true;
        }
        this.setState({ accordianStatus });
    }

    getAccordianComponent = (name, index = '') => {
        let { showLoaderIndex } = this.state;
        let { accordianComponent } = this.state;
        let { formName, prefix } = this.props;
        if (name === 'analytics-preview') {
            accordianComponent[index] = <AnalyticsPreview isListView={true} formIndex={index} formData={this.state.formData} source={`list-table`} formname={formName} />;
        } else if (name === 'campaign-analytics' || name === 'automation-analytics') {
            accordianComponent[index] = <Analytics formIndex={index} formData={this.state.formData} source={prefix} formname={formName} analyticsConfig={this.props.analyticsConfig} />;
        }
        this.setState({ accordianComponent });

        setTimeout(() => {
            showLoaderIndex[index] = true;
            this.setState({ ...showLoaderIndex });
        }, 1000);

    }

    handleChangeSwitch = (status, id) => {
        let { switchOptions } = this.props;
        switchOptions.handleSwitchChange(status, id);
    }

    cloneAction = (e, data) => {
        let { cloneOperation } = this.props;
        cloneOperation(data);
    }

    deleteAction = async (e, formName, formid, isTableForm = false) => {

        let { deleteCallBack } = this.props;

        let isConfirm = await confirmBoxWithImage("Delete", "Are you sure you want to delete?", "");
        if (isConfirm) {
            e.preventDefault();
            let params = {
                "ENTITY": "WHATSAPPPROCESS",
                "OPERATION": "DELETE",
                "FORMNAME": formName,
                "formid": formid,
                "isTableForm": isTableForm,
                "isOtherApiReq": true,
            }
            let res = await requestApi.processServerRequest(params);
            if (res.issuccess) {
                if (deleteCallBack !== undefined && deleteCallBack) {
                    deleteCallBack();
                } else {
                    showToast("Deleted Successfully!", 'top-right', 'success', function () {
                        window.location.reload();
                    }, 1500);
                }
            }
        }
    }

    onMasterCheck = async (e, formData, formName) => {
        let { selectedRows, masterChecked } = this.state;

        if (!masterChecked) {
            for (let i in formData) {
                selectedRows.push(formData[i][formName + "_id"]);
            }
        } else {
            selectedRows = [];
        }

        this.setState({
            masterChecked: !masterChecked,
            selectedRows
        })
    }

    onItemChecked = (e, rowId) => {

        let { selectedRows, masterChecked, formData } = this.state;
        let index = selectedRows.indexOf(rowId);

        if (index > -1) {
            selectedRows.splice(index, 1); // 2nd parameter means remove one item only
        } else {
            selectedRows.push(rowId);
        }
        selectedRows = removeDuplicateValues(selectedRows);
        masterChecked = selectedRows.length === formData.length ? true : false;

        this.setState({
            selectedRows: selectedRows,
            isNeedMassEditPanel: selectedRows.length > 0,
            masterChecked
        });

    }

    refreshCheckBox = (clickedValue) => {
        let { isToastNeeded } = this.props;
        if (clickedValue !== undefined && clickedValue !== null) {
            if (isToastNeeded === undefined || isToastNeeded) {
                showToast(clickedValue + " is Successfully changed", 'top-right', 'success')
            }
            this.setState({
                selectedRows: [],
                masterChecked: false,
            })
        }
    }

    render() {

        let rows = [];
        let { key, noDataMsg, pagination, onPageChange, currentPage, totalCount, limit, showAccordian, isTableForm, accordianName, isDeleteNeeded, isOnlyOwnerDelete, viewNeeded, isCheckboxNeeded, checkBoxPopupData, analyticsNeeded, prefix, customClass, headerConfig, analyticsName, formName, isCloneNeeded, switchOptions } = this.props;
        let { formData, fields, showRowCount, config, spaceBeforeCell, labelIndex, aliasIndex, accordianStatus, accordianComponent, userid, userformname } = this.state;
        let rowCount = currentPage !== undefined ? (currentPage - 1) * limit : 0;
        let { customRowConfig } = this.props;
        if (formData === undefined || formData === null || formData.length === 0) {

        }
        customClass = customClass === undefined ? "" : customClass;
        isDeleteNeeded = (isDeleteNeeded === undefined) ? false : isDeleteNeeded;
        let isViewNeeded = (viewNeeded === undefined) ? false : viewNeeded;
        let isAnalyticsNeeded = (analyticsNeeded === undefined) ? false : analyticsNeeded;
        analyticsName = (analyticsName === undefined) ? "Analytics" : analyticsName;
        let today = dateFormat(new Date(), 'dd/mm/yyyy');
        let yesterday = dateFormat(new Date(Date.now() - 86400000), 'dd/mm/yyyy');
        let fieldNameList = [];
        let fieldAliasList = [];
        let hideCustomColumn = false;

        if (fields != undefined && fields.length > 0) {
            fieldNameList = fields[0];
            fieldAliasList = fields[1];
        } else {
            hideCustomColumn = true;
        }

        if (fieldNameList == undefined || fieldNameList.length < 0) {
            return <></>
        }

        if (isTableForm === undefined) {
            isTableForm = true;
        }

        let isSwitchNeeded = switchOptions ? switchOptions.isSwitchNeeded : false;
        let switchheader = switchOptions ? switchOptions.header : false;
        let checkedValue = switchOptions ? switchOptions.checkedValue : false;
        let switchname = switchOptions ? switchOptions.name : false;
        let switchfieldid = switchOptions ? switchOptions.fieldid : "";
        let switchfieldvalue = switchOptions ? switchOptions.fieldvalue : "";
        let switchchangeOnlyOwner = switchOptions ? switchOptions.changeOnlyOwner : false;

        return (
            <Fragment key={key}>
                <Table bordered hover className={cx(`le-table ${customClass}`,
                    { '': !spaceBeforeCell }
                )}>
                    <thead>
                        <tr>
                            {
                                isCheckboxNeeded ?
                                    <th key={randstr('th_')} className={cx('custom-table-header w-6-1 ws-n', { 'hide': !isCheckboxNeeded || hideCustomColumn })}>
                                        <div className={cx('d-flex-v ckbox-container', { 'checkbox-not-selected ': this.state.selectedRows.length === 0 }, { 'checkbox-selected': this.state.selectedRows.length !== 0 })}>
                                            <span className="input-hover ckbox-custom">
                                                <input
                                                    type={`checkbox`}
                                                    checked={this.state.masterChecked}
                                                    indeterminate={`true`}
                                                    onClick={(e) => this.onMasterCheck(e, formData, formName)}
                                                    className={cx("custom-checkbox-select cursor-hover mr-1")}
                                                />
                                            </span>
                                            <UncontrolledButtonDropdown >
                                                <DropdownToggle color="link" className={cx('p-0 dropdown-listtbl-icon', { 'btn-disabled': this.state.selectedRows.length === 0 }, { 'btn-enable': this.state.selectedRows.length !== 0 })}>
                                                    <div className="toggle-btn">
                                                        <FontAwesomeIcon icon={faCaretDown} />
                                                    </div>
                                                </DropdownToggle>
                                                <DropdownMenu end className="rm-pointers dropdown-menu-md" >
                                                    <Nav vertical >
                                                        {
                                                            checkBoxPopupData && checkBoxPopupData.length > 0 ?
                                                                checkBoxPopupData.map((data, index) => {
                                                                    return (
                                                                        <NavItem key={index} onClick={(e) => { this.refreshCheckBox(data.value) }}>
                                                                            <NavLink
                                                                                href="#"
                                                                                className="dropdown-popup-data"
                                                                                onClick={(e) => this.props.renderElements("popupShow", formData, data.value, this.state.selectedRows)}
                                                                            >
                                                                                <span>{data.label}</span>
                                                                            </NavLink>
                                                                        </NavItem>
                                                                    );
                                                                }) : null
                                                        }
                                                    </Nav>
                                                </DropdownMenu>
                                            </UncontrolledButtonDropdown>
                                        </div>
                                    </th> : null
                            }


                            {
                                showAccordian &&
                                <th key={randstr('th_')} />
                            }
                            {
                                fieldNameList.length > 0 && showRowCount &&
                                <th className={`w-6 ${isCheckboxNeeded ? 'text-left' : ''}`} key={randstr('th_')}>#</th>
                            }
                            {
                                fieldNameList.map((field) => {

                                    let customHeaderClass = "";

                                    if (headerConfig !== undefined && headerConfig[field] !== undefined) {
                                        if (headerConfig[field].class !== undefined && headerConfig[field].class !== "" && headerConfig[field].class !== null) {
                                            customHeaderClass = headerConfig[field].class;
                                        }
                                    }

                                    return (<th className={`${field == 'name' ? 'text-start' : ''}  ${customHeaderClass}`} key={randstr('th_')}>{field}</th>)
                                })
                            }
                            {isSwitchNeeded ? <th key={randstr('th_')} className={cx('custom-table-header w-5 ', { 'hide': !isSwitchNeeded || hideCustomColumn })}>{switchheader}</th> : null}
                            {isCloneNeeded ? <th key={randstr('th_')} className={cx('custom-table-header w-5 ', { 'hide': !isCloneNeeded || hideCustomColumn })}>Clone</th> : null}
                            {isDeleteNeeded ? <th key={randstr('th_')} className={cx('custom-table-header w-5 ', { 'hide': !isDeleteNeeded || hideCustomColumn })}>Delete</th> : null}
                            {isViewNeeded ? <th key={randstr('th_')} className={cx('custom-table-header', { 'hide': !isViewNeeded || hideCustomColumn })}>Log</th> : null}
                            {isAnalyticsNeeded ? <th key={randstr('th_')} className={cx('custom-table-header w-5', { 'hide': !isAnalyticsNeeded || hideCustomColumn })}>{analyticsName}</th> : null}
                        </tr>
                    </thead>
                    {formData.length > 0 ?
                        <tbody>
                            {
                                formData.length > 0 &&
                                formData.forEach((data, index) => {
                                    let onClickMethod = "";
                                    let customClass = "";
                                    let customMsg = "";
                                    let formId = isTableForm ? data[formName + '_id'] : data['id'];
                                    let viewLink = "";
                                    let disableDeleteBtn = false;
                                    let switchDisabled = false;
                                    if (isViewNeeded) {
                                        if (prefix === "campaigns") {
                                            viewLink = "#/deliverylog/" + prefix + "/" + formId;
                                        }
                                    }
                                    if (isOnlyOwnerDelete) {
                                        let createduserid = data[userformname + "_0_" + userformname + "_id"];
                                        if (userid !== createduserid) {
                                            disableDeleteBtn = true;
                                        }
                                    }

                                    if (switchchangeOnlyOwner) {
                                        let createduserid = data[userformname + "_0_" + userformname + "_id"];
                                        if (userid !== createduserid) {
                                            switchDisabled = true;
                                        }
                                    }
                                    if (customRowConfig !== undefined) {
                                        let link = customRowConfig.link;
                                        if (link.condition !== "") {
                                            let condition = link.condition.split("#");
                                            let condField = condition[0];
                                            let condValue = condition[1];
                                            let condArr = condValue.split(",");
                                            if (condArr.includes(data[condField])) {
                                                onClickMethod = link.onClick;
                                                customClass = link.class;
                                            }
                                        } else if (link.condition === "") {
                                            onClickMethod = link.onClick;
                                            customClass = link.class;
                                        } else {
                                            customMsg = "Can't edit the campaign when status is not Draft";
                                        }
                                    }
                                    (rows.push(
                                        <Fragment>
                                            <tr className={customClass} tooltip={customMsg} key={index}>
                                                {
                                                    isCheckboxNeeded ?
                                                        <td className={'text-left'} key={randstr('td_')}>
                                                            <input
                                                                type={`checkbox`}
                                                                onClick={(e) => this.onItemChecked(e, formData[index][formName + "_id"])}
                                                                className={`row-ckbox cursor-hover ${this.state.isCheckBoxEnabled.includes(formData[index][formName + "_id"]) || this.state.selectedRows.includes(formData[index][formName + "_id"]) ? '' : ''}`}
                                                                checked={this.state.selectedRows.includes(formData[index][formName + "_id"])}
                                                            />
                                                        </td> : null
                                                }

                                                {
                                                    showAccordian &&
                                                    <td key={randstr('td_')} onClick={() => { this.toggleAccordian(index) }} >
                                                        <span className={`le-table-accordian-icon`}>
                                                            <FontAwesomeIcon icon={accordianStatus[index] ? faMinus : faPlus} />
                                                        </span>
                                                    </td>
                                                }
                                                {
                                                    showRowCount &&
                                                    <td className={`${isCheckboxNeeded ? 'text-left' : ''}`} key={randstr('td_')}>{++rowCount}</td>
                                                }
                                                {
                                                    fieldNameList.map((fielddata, findex) => {
                                                        let classNames = '';
                                                        let showPopover = false;
                                                        let labelName = fieldNameList[findex];
                                                        let aliasName = fieldAliasList[findex];
                                                        let columnvalue = data[aliasName];
                                                        /*
                                                        let labelName = fielddata[labelIndex];
                                                        let columnvalue = data[labelName];
                                                        let aliasName = fielddata[aliasIndex];
                                                        */

                                                        let renderElement = undefined;

                                                        if (config[aliasName] !== undefined) {
                                                            showPopover = config[aliasName].popover ? true : false;

                                                            if (config[aliasName].decode || config[aliasName].decodeWithParse) {
                                                                if (columnvalue !== '' && columnvalue !== null) {
                                                                    columnvalue = decodeString(columnvalue, config[aliasName].decodeWithParse ? true : false);
                                                                    if (columnvalue !== "" && typeof columnvalue === "string") {
                                                                        columnvalue = columnvalue.replace(/\\n/g, '');
                                                                    }
                                                                }
                                                            }

                                                            if (config[aliasName].class) {
                                                                classNames = config[aliasName].class;
                                                            }

                                                            if (config[aliasName].toUTCDate) {
                                                                if (columnvalue !== undefined && columnvalue !== '' && columnvalue !== null) {
                                                                    columnvalue = convertDateToUtc(columnvalue);
                                                                }
                                                            }

                                                            if (config[aliasName].toLocalDate) {
                                                                if (columnvalue !== undefined && columnvalue !== '' && columnvalue !== null) {
                                                                    if (columnvalue.indexOf("<span") > -1) {
                                                                        var stringArr = columnvalue.split('>');
                                                                        if (stringArr.length > 1) {
                                                                            columnvalue = stringArr[1].replace("</span", "");
                                                                        }
                                                                    }
                                                                    let format = config[aliasName].dateformat === undefined ? "dd-mmm-yyyy h:MM TT" : config[aliasName].dateformat;
                                                                    columnvalue = convertUTCToLocalTime(columnvalue, format);
                                                                }
                                                            }

                                                            if (config[aliasName].format) {
                                                                if (columnvalue !== undefined && columnvalue !== '' && columnvalue !== null && columnvalue !== "0000-00-00") {
                                                                    let columndate = dateFormat(columnvalue, 'dd/mm/yyyy');
                                                                    if (columndate === today) {
                                                                        columnvalue = 'Today';
                                                                    } else if (columndate === yesterday) {
                                                                        columnvalue = 'Yesterday';
                                                                    } else {
                                                                        columnvalue = dateFormat(columnvalue, config[aliasName].format);
                                                                    }
                                                                }
                                                            }

                                                            if (config[aliasName].capitalize) {
                                                                columnvalue = (columnvalue !== undefined) ? columnvalue.toUpperCase() : columnvalue;
                                                            }

                                                            //Dynamically render elements from props
                                                            if (config[aliasName].render) {
                                                                if (this.props.renderElements !== undefined) {
                                                                    renderElement = this.props.renderElements(config[aliasName].render, data, fielddata, this.props, this.state);
                                                                }
                                                            }
                                                        }
                                                        //if(fielddata[2] !== undefined && fielddata[2] === "Template" && columnvalue !== ""){
                                                        //    columnvalue = columnvalue.split("#")[1];
                                                        //}
                                                        return (
                                                            <td
                                                                key={randstr('td_')}
                                                                id={`col-${index}-${aliasName}`}
                                                                className={`${labelName == 'name' && aliasName == '6' ? 'custom-width-4 text-start' : ''} ${classNames}`}
                                                                onClick={(event => {

                                                                    let disableLinkAction = false;

                                                                    if (
                                                                        config[aliasName] !== undefined &&
                                                                        config[aliasName].disableLink !== undefined &&
                                                                        config[aliasName].disableLink
                                                                    ) {
                                                                        disableLinkAction = true;
                                                                    }

                                                                    if (!disableLinkAction && onClickMethod !== "") {
                                                                        onClickMethod(event, formId, data);
                                                                    }
                                                                })}
                                                            >

                                                                {
                                                                    renderElement !== undefined ?
                                                                        renderElement : <div dangerouslySetInnerHTML={{ __html: columnvalue }} ></div>
                                                                }
                                                                {
                                                                    showPopover &&
                                                                    <UncontrolledPopover placement={"bottom"} trigger="hover" fade={false} target={`col-${index}-${aliasName}`}>
                                                                        <PopoverHeader className={`le-tooltip`}></PopoverHeader>
                                                                        <PopoverBody className={`le-tooltip`}>
                                                                            {columnvalue}
                                                                        </PopoverBody>
                                                                    </UncontrolledPopover>
                                                                }
                                                            </td>
                                                        )
                                                    })
                                                }
                                                {
                                                    isSwitchNeeded ?
                                                        <td key={randstr('td_')} className={cx('custom-table-body row-link', { 'hide': !isSwitchNeeded })} >
                                                            <Switch height={15} width={30} disabled={switchDisabled} name={switchname} onColor={"#23ae73"} checked={data[switchfieldvalue] === checkedValue} onChange={e => { this.handleChangeSwitch(e, data[switchfieldid]) }} />
                                                        </td>
                                                        : null
                                                }
                                                {
                                                    isCloneNeeded ?
                                                        <td key={randstr('td_')} className={cx('custom-table-body row-link', { 'hide': !isCloneNeeded })} onClick={(e) => { this.cloneAction(e, data) }} ><FontAwesomeIcon icon={faCopy} /></td>
                                                        : null
                                                }
                                                {
                                                    isDeleteNeeded ?
                                                        <td key={randstr('td_')} className={cx('custom-table-body row-link', { 'hide': !isDeleteNeeded }, { "disabled-button": disableDeleteBtn })} onClick={(e) => { this.deleteAction(e, formName, formId, isTableForm) }} ><FontAwesomeIcon icon={faTrash} /></td>
                                                        : null
                                                }
                                                {
                                                    isViewNeeded ?
                                                        <td key={randstr('td_')} className={cx('custom-table-body row-link', { 'hide': !isViewNeeded })}><a href={viewLink} target="_blank"><FontAwesomeIcon icon={faEye} /></a></td>
                                                        : null
                                                }
                                                {
                                                    isAnalyticsNeeded ?
                                                        <td className={cx('custom-table-body row-link')} key={randstr('td_')} onClick={() => { this.toggleAccordian(index) }} >
                                                            <span className={`le-table-accordian-icon`}>
                                                                <FontAwesomeIcon icon={accordianStatus[index] ? faAnglesUp : faAnglesDown} />
                                                            </span>
                                                        </td>
                                                        : null
                                                }

                                            </tr>
                                            <tr className={`${cx("le-table-accordian", { "hide": !accordianStatus[index] })}`}>
                                                <td colSpan={9}>
                                                    <div>
                                                        <Collapse className={'w-100 list-analytic-count font-color-theme'} isOpen={accordianStatus[index]} onEntering={() => { this.getAccordianComponent(accordianName, index) }}>
                                                            {
                                                                this.state.showLoaderIndex[index] ? accordianComponent[index] !== undefined && accordianComponent[index] : "Loading..."
                                                            }
                                                        </Collapse>
                                                    </div>
                                                </td>
                                            </tr>
                                        </Fragment>
                                    ));
                                })
                            }
                            {rows}
                        </tbody>
                        : <div></div>
                    }

                </Table>
                {formData.length === 0 ? <NoRecord msg={noDataMsg} /> : <div></div>}
                {
                    pagination && (formData.length !== 0 && totalCount > limit) &&
                    <div className={`pagination-wrapper`}>
                        <div className={`pagination-box`}>
                            <Paginate
                                onPageClick={onPageChange}
                                currentPage={currentPage}
                                totalCount={totalCount}
                                limit={limit}
                            />
                        </div>
                    </div>
                }

            </Fragment>
        );
    }
}
